<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <Finance /> -->
  </div>
</template>

<script>
// import Finance from "vue-material-design-icons/Finance.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiFinance } from "@mdi/js"

export default {
  name: "FinanceIcon",
  components: {
    SvgIcon
    // Finance,
  },
  data() {
    return {
      path: mdiFinance,
    }
  }
}
</script>
